import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/components/auth/AuthProvider";

export const useIsAdmin = () => {
  const { userId, loading: authLoading } = useAuth();

  const { data: isAdmin, isLoading: queryLoading } = useQuery({
    queryKey: ["user-admin-status", userId],
    queryFn: async () => {
      if (!userId) {
        return false;
      }

      const { data: roleData, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId)
        .single();

      if (error) {
        console.error("Error checking admin status:", error);
        return false;
      }

      return roleData?.role === "admin";
    },
    enabled: !authLoading && !!userId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return { 
    isAdmin: isAdmin ?? false,
    isLoading: authLoading || queryLoading
  };
};
